import { CheckPoint } from 'modules/Distances/components/shared/Steps/GPX/types';

import { checkPointService } from 'src/modules/Distances/components/shared/Steps/GPX/services';

export const validateCheckpointCoordinates = (checkpoint: CheckPoint) => {
  checkPointService.validateCheckPointCoordinates(checkpoint);
};
